const DEFAULT_MESSAGES = {
  en: {
    'UNKNOWN_API_ERROR': 'Oops!',
    'DEFAULT_ERROR_MESSAGE': 'We\'re experiencing temporary connectivity issues and are working on a fix. Please try again soon.',
    'WERE_SORRY': 'We\'re Sorry',
    'APP_STARTOVER': 'Try Again',
    'DEFAULT_PAGE_TITLE': 'AeroMexico',
    'PO_LOAD_MSG1': 'This will take a moment...',
    'PO_LOAD_MSG2': 'Hold tight!',
    'PO_LOAD_MSG3': 'Processing your payment...',
    'CONFIRMATION_FREE_STANDARD_BAGS' : '{numBags, plural, =1 {# standard bag INCLUDED} other {# standard bags INCLUDED}}',
    'STANDARD_BAG_DROPDOWN': '{numBags, plural, =1 {# standard bag} other {# standard bags}}',
  },
  es: {
    'UNKNOWN_API_ERROR': '¡Ups!',
    'DEFAULT_ERROR_MESSAGE': 'Estamos experimentando problemas de conexión temporales y estamos trabajando para resolverlos. Por favor inténtalo de nuevo más tarde.',
    'WERE_SORRY': 'Lo sentimos',
    'APP_STARTOVER': 'Inténtalo de nuevo',
    'DEFAULT_PAGE_TITLE': 'AeroMexico',
    'PO_LOAD_MSG1': 'Esto tomará un momento...',
    'PO_LOAD_MSG2': 'Espera un poco...',
    'PO_LOAD_MSG3': 'Estamos procesando tu pago...',
    'CONFIRMATION_FREE_STANDARD_BAGS' : '{numBags, plural, =1 {# maleta estándar INCLUIDA} other {# maletas estándar INCLUIDAS}}',
    'STANDARD_BAG_DROPDOWN': '{numBags, plural, =1 {# maleta estándar} other {# maletas estándar}}',
  },
  pt: {
    'UNKNOWN_API_ERROR': '¡Ups!',
    'DEFAULT_ERROR_MESSAGE': 'Estamos enfrentando problemas temporários de rede mas estamos trabalhando para resolvê-los. Por favor, tente novamente mais tarde.',
    'WERE_SORRY': 'Sentimos muito',
    'APP_STARTOVER': 'Tente novamente',
    'DEFAULT_PAGE_TITLE': 'AeroMexico',
    'PO_LOAD_MSG1': 'Isso pode demorar um pouco ...',
    'PO_LOAD_MSG2': 'Aguarde um momento...',
    'PO_LOAD_MSG3': 'Estamos processando seu pagamento ...',
    'CONFIRMATION_FREE_STANDARD_BAGS' : '{numBags, plural, =1 {# bagagem standard INCLUÍDA} other {# bagagens stándard INCLUÍDA}}',
    'STANDARD_BAG_DROPDOWN': '{numBags, plural, =1 {# Bagagem standard} other {# Bagagens standard}}',
  },
  fr: {
    'UNKNOWN_API_ERROR': '¡Ups!',
    'DEFAULT_ERROR_MESSAGE': 'Nous rencontrons actuellement des problèmes de connexions temporaires et nous faisons tout notre possible pour les résoudre. Veuillez réessayer ultérieurement.',
    'WERE_SORRY': 'Nous sommes désolés.',
    'APP_STARTOVER': 'Veuillez réessayez',
    'DEFAULT_PAGE_TITLE': 'AeroMexico',
    'PO_LOAD_MSG1': 'Cela prendra quelques instants...',
    'PO_LOAD_MSG2': 'Veuillez patienter quelques instants...',
    'PO_LOAD_MSG3': 'Nous sommes en train de procéder à votre paiement...',
    'CONFIRMATION_FREE_STANDARD_BAGS' : '{numBags, plural, =1 {# bagage standard INCLUS} other {# bagages standard INCLUS}}',
    'STANDARD_BAG_DROPDOWN': '{numBags, plural, =1 {# bagage standard} other {# bagages standard}}',
  },
};

const getDefaultMessage = (language, copyID) => {
  return DEFAULT_MESSAGES[language] && DEFAULT_MESSAGES[language][copyID];
};

export default getDefaultMessage;
